import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

export default function CngBackdrop(props) {
  const classes = useStyles()

  return props.loading ? (
    <div>
      <Backdrop className={classes.backdrop} open={props.loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  ) : null
}
